import { observer } from 'mobx-react-lite';
import BorderPanel from './BorderPanel';
import type { BorderPanelProps, BorderPanelValueProps } from './types';

export type { BorderPanelProps, BorderPanelValueProps };
export default observer(BorderPanel); // MANUAL OVERRIDE
